bovoApp.
factory('Dayend', ['$http', function($http) {
    return {
      all: function(data) {
        return $http.post('api/dayends',data);
      },
      get: function(id) {
        return $http.get('api/dayend/' + id);
      },
      new: function(id) {
        return $http.get('api/new-dayend');
      },
      delete: function(id) {
        return $http.delete('api/delete-dayend/' + id);
      },
      save: function(data) {
        return $http.post('api/save-dayend',data);
      },
      update: function(data) {
        return $http.post('api/update-dayend',data);
      },
      completeDayend: function(data) {
        return $http.post('api/complete-dayend',data);
      },
      unCompleteDayend: function(data) {
        return $http.post('api/un-complete-dayend',data);
      }
    };
}]);